<template>
  <div class="recommend-list">

    <van-search 
      placeholder="请输入姓名/职位/订单ID等" 
      v-model="keyword" 
      shape="round"
      left-icon=""
      @search="onSearch">
    </van-search>
		
  </div>
</template>

<script>

export default {
  name: "recommendSearch",
  components: {
  },
  data(){
  	return {
      keyword: this.$route.query.keyword||''
  	}
  },
  methods: {
    onSearch(){
      let params = {...this.$route.query};
      params.keyword = this.keyword;
      if(!this.keyword)
        delete params.keyword;

      this.$router.replace({name: this.$route.name, query: {...params}});
    }
  },
  watch: {
    
  },
  created() {}
};
</script>

<style lang="scss" scoped>
  .van-list{
    background: #f5f5f5;
  }
</style>
